export var commonId;
(function (commonId) {
    commonId["recommendations"] = "recommendations";
})(commonId || (commonId = {}));
export var marketsRoute = {
    markets: "/markets",
};
export var viewInDetail = {
    viewall: "/viewall",
};
export var MarketTabsConstants = {
    Equity: "equity",
    MutualFunds: "mutualFunds",
    PrimaryMarket: "primaryMarket",
    NCDs: "ncds",
    Futures: "futures",
    Options: "options",
    Currency: "currency",
    Commodity: "commodity",
    ETFs: "etfs",
    OptionTool: "option-tool",
};
